import Vue from 'vue';

export default Vue.extend({
    data() {
        return {
            text: '',
            valueGetter: null
        };
    },
    watch: {
        text: function(val, oldVal) {
            if (val !== oldVal) {
                this.params.filterChangedCallback();
            }
        }
    },
    created() {
        this.valueGetter = this.params.valueGetter;
    },
    methods: {
        isFilterActive() {
            return this.text && this.text !== null && this.text !== '';
        },

        doesFilterPass(params) {
            return (
                !this.text ||
                this.text
                    .toLowerCase()
                    .split(' ')
                    .every(filterWord => {
                        return (
                            this.valueGetter(params.node)
                                .toString()
                                .toLowerCase()
                                .indexOf(filterWord) >= 0
                        );
                    })
            );
        },

        getModel() {
            return { value: this.text };
        },

        setModel(model) {
            if (model) {
                this.text = model.value;
            }
        },

        afterGuiAttached() {
            this.$refs.input.focus();
        },

        componentMethod(message) {
            alert(`Alert from PartialMatchFilterComponent ${message}`);
        }
    },
    template: '<input style="height: 20px" :ref="\'input\'" v-model="text">'
});



// WEBPACK FOOTER //
// ./src/views/my/planTemplate/components/customizeFilter.js